export default __webpack_public_path__ + "static/media/310.8b5c168e.jpg";